import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Type } from '../Type/Type';
var levelSizeMap = {
  large: 3,
  medium: 2,
  small: 1
};

/**
 * Body abstraction over Type. We spread the constrained Body
 * props last and explicitly set others to undefined to prevent them from
 * being overridden.
 *
 * For example, all Body text should be gotham and have normal weight.
 */
export var Body = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["size", "children"]);

  return /*#__PURE__*/React.createElement(Type, _extends({}, otherProps, {
    chronicle: undefined,
    color: undefined,
    gotham: true,
    uppercase: undefined,
    size: levelSizeMap[size],
    ref: ref
  }), children);
});
Body.displayName = 'Body';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require -- directive added automatically by Shepherd migration
  var PropTypes = require('prop-types');

  Body.propTypes = {
    /**
     * Bold styling.
     */
    bold: PropTypes.bool,

    /**
     * The content that the Type component will compose.
     */
    children: PropTypes.node.isRequired,

    /**
     * Use a custom component instead of the default <p> component.
     */
    component: PropTypes.any,
    // eslint-disable-line react/forbid-prop-types

    /**
     * By default <Type> is block-level (renders a <p> tag). If the inline prop
     * is used, <Type> is inline (renders a <span> tag).
     */
    inline: PropTypes.bool,

    /**
     * Italic styling.
     */
    italic: PropTypes.bool,

    /**
     * Sets text to "neutral-darker" defined in base-styles.
     */
    light: PropTypes.bool,

    /**
     * The suitable sizes for the TitleText. See the Type Guidelines for details.
     */
    size: PropTypes.oneOf(Object.keys(levelSizeMap))
  };
}